/* eslint-disable @atlassian/relay/graphql-naming */
/* eslint-disable jira/filename-case */
import React from 'react';
// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
import { graphql, useFragment } from 'react-relay';
import { Header as DirectoryHeader } from '@atlassian/jira-directory-base-v3/src/ui/header/index.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import { useIntl } from '@atlassian/jira-intl';
import type { Header$key } from '@atlassian/jira-relay/src/__generated__/Header.graphql';
import { useIsAnonymous } from '@atlassian/jira-tenant-context-controller/src/components/is-anonymous/index.tsx';
import { CreateButton } from './create-project-action/CreateButton.tsx';
import messages from './messages.tsx';
import { OpenTemplatesPanelButton } from './open-templates-panel/OpenTemplatesPanelButton.tsx';

type Props = {
	dataRef: Header$key;
	isAdminSettingsContext: boolean;
};

export const Header = ({ dataRef, isAdminSettingsContext }: Props): React.JSX.Element => {
	const adminHeaderCaptionGalaxia = expVal('project-terminology-refresh', 'isEnabled', false)
		? messages.adminHeaderCaptionGalaxia
		: messages.adminHeaderCaption;
	const headerCaptionGalaxia = expVal('project-terminology-refresh', 'isEnabled', false)
		? messages.headerCaptionGalaxia
		: messages.headerCaption;
	const { formatMessage } = useIntl();

	const { jira } = useFragment(
		// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
		graphql`
			fragment Header on Query @argumentDefinitions(isAnonymous: { type: "Boolean!" }) {
				jira {
					...CreateButton
					...OpenTemplatesPanelButton @skip(if: $isAnonymous)
				}
			}
		`,
		dataRef,
	);

	const isAnonymous = useIsAnonymous();

	return (
		<DirectoryHeader
			title={
				isAdminSettingsContext
					? formatMessage(adminHeaderCaptionGalaxia)
					: formatMessage(headerCaptionGalaxia)
			}
			actions={
				jira ? (
					<>
						<CreateButton dataRef={jira} />
						{!isAnonymous && <OpenTemplatesPanelButton dataRef={jira} />}
					</>
				) : undefined
			}
			isAdminSettingsContext={isAdminSettingsContext}
		/>
	);
};
